/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AccountProfileEditorTableStaffFragment = { name: string | null, profile: { avatar: any } };

export const AccountProfileEditorTableStaffFragmentDoc = gql`
    fragment AccountProfileEditorTableStaff on Staff {
  name
  profile {
    avatar
  }
}
    `;